export enum SubjectType {
  PROFILE = 'profile',
  DEVIATION = 'deviation',
  FORUM = 'forum',
  COLLECTION = 'collection',
  COMMISSION = 'commission',
}
